module.exports = __webpack_public_path__ + "static/media/025.e4c29552.jpg";